import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import {
  StorageValidationProjectResumeModel,
  StorageValidationProjectResumeTableModel,
} from 'src/app/models/configurators-2d/applications/storage/validation/storage-validation-models';
import { CustomerService } from 'src/app/services/customer.service';
import { TunnelService } from 'src/app/services/tunnel.service';

@Component({
  selector: 'ng-validation-project-resume',
  templateUrl: './validation-project-resume.component.html',
})
export class ValidationProjectResumeComponent implements OnInit, OnDestroy {
  @Input() model$: Observable<StorageValidationProjectResumeModel>;
  private _modelSubscription: Subscription;

  @Input() loading$: Observable<boolean>;

  public model: StorageValidationProjectResumeModel;
  public loading: boolean;

  public readonly validationProjectResume: BehaviorSubject<StorageValidationProjectResumeTableModel> =
    new BehaviorSubject<StorageValidationProjectResumeTableModel>(undefined);

  constructor(private readonly injector: Injector) {}

  ngOnInit(): void {
    this.subscribeToObservables();
    this.resetFidelityCardPoint();
  }

  ngOnDestroy(): void {
    this._modelSubscription?.unsubscribe();
  }

  private subscribeToObservables() {
    this._modelSubscription = this.model$.subscribe(model => {
      if (model) {
        this.model = model;
        this.buildValidationProjectResumeModel();
      }
    });
  }

  private buildValidationProjectResumeModel() {
    const tunnelService = this.injector.get(TunnelService);
    const customerService = this.injector.get(CustomerService);

    const validationProjectResumeModel: StorageValidationProjectResumeTableModel = {
      totalPriceBom: tunnelService.storageTunnelData.totalPriceBomWithDiscount,
      fidelityAdvantageValidationModel: {
        amount: tunnelService.storageTunnelData.totalFundingCost,
        customer: customerService.userDatas,
      },

      interest: tunnelService.storageTunnelData.interest,
      downPayment: tunnelService.storageTunnelData.downPayment,
      duration: tunnelService.storageTunnelData.duration,
      mensuality: tunnelService.storageTunnelData.mensuality,
      montantTotal: tunnelService.storageTunnelData.totalFundingCost,
    };
    this.validationProjectResume.next(validationProjectResumeModel);
  }

  private resetFidelityCardPoint() {
    this.injector.get(TunnelService).resetFidelityCardPoint();
  }
}
